"use client";

import { SAKA_COOKIE_NAMES } from "@/constants/cookieNames";
import { CURRENCIES, DEFAULT_CURRENCY } from "@/constants/currency";
import { normalizeLocale } from "@/i18n/normalizeLocale";
import { routing } from "@/i18n/routing";
import Cookies from "js-cookie";

/**
 * Client-side locale helper
 * @returns {string} Locale code
 */
export function getClientLocale() {
  try {
    const localeCode = Cookies.get(SAKA_COOKIE_NAMES.LOCALE);

    return normalizeLocale(localeCode) || routing.defaultLocale;
  } catch (error) {
    console.error("Error getting client locale:", error);
    return routing.defaultLocale;
  }
}

/**
 * Client-side currency helper
 * @returns {string} Currency code
 */
export function getClientCurrency() {
  try {
    const currencyCode = Cookies.get(SAKA_COOKIE_NAMES.CURRENCY);

    if (currencyCode && CURRENCIES[currencyCode]) {
      return currencyCode;
    }

    return DEFAULT_CURRENCY;
  } catch (error) {
    console.error("Error getting client currency:", error);
    return DEFAULT_CURRENCY;
  }
}

/**
 * Client-side session helper
 * @returns {object|null} Session data
 */
export function getClientSession() {
  try {
    const sessionCookie = Cookies.get(SAKA_COOKIE_NAMES.SESSION);

    if (sessionCookie) {
      try {
        return JSON.parse(sessionCookie);
      } catch {
        // Invalid format
        return null;
      }
    }

    return null;
  } catch (error) {
    console.error("Error getting client session:", error);
    return null;
  }
}

/**
 * Client-side session setter helper
 * @param {object} sessionData - Session data to save
 */
export function setClientSession(sessionData) {
  try {
    Cookies.set(SAKA_COOKIE_NAMES.SESSION, JSON.stringify(sessionData), {
      expires: 365,
      path: "/",
      sameSite: "strict",
    });
  } catch (error) {
    console.error("Error setting client session:", error);
  }
}

/**
 * Client-side locale setter helper
 * @param {string} locale - Locale code to save
 */
export function setClientLocale(locale) {
  try {
    const normalized = normalizeLocale(locale);
    if (normalized) {
      Cookies.set(SAKA_COOKIE_NAMES.LOCALE, normalized, {
        expires: 365,
        path: "/",
        sameSite: "strict",
      });
    }
  } catch (error) {
    console.error("Error setting client locale:", error);
  }
}

/**
 * Client-side currency setter helper
 * @param {string} currency - Currency code to save
 */
export function setClientCurrency(currency) {
  try {
    if (CURRENCIES[currency]) {
      Cookies.set(SAKA_COOKIE_NAMES.CURRENCY, currency, {
        expires: 365,
        path: "/",
        sameSite: "strict",
      });
    }
  } catch (error) {
    console.error("Error setting client currency:", error);
  }
}
